<div class="header-modal mb-0">
  <div class="main-title w-100 mt-0 mb-0">
    <h3>{{data.fullName ? data.fullName : ('Delete ' + data.name)}}</h3>
  </div>

  <span class="close-dialog" (click)="noDelete()">
      <i class="material-icons">close</i>
  </span>
</div>

<div mat-dialog-content *ngFor="let ids of data.name">
  <a>Standard: {{ids}}</a>
</div>

<div class="footer-modal footer-modal--center mt-20">
  <cmp-button [class]="'cancel mr-20'" text="Cancel" (click)="noDelete()"></cmp-button>
</div>
